import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { connect } from "react-redux";

import { Card } from "antd";
import Pager from "components/site/Pager";
import UserLayout from "components/layout/UserLayout";
import UserNavs from "components/users/UserNavs";
import PostListItem from "components/post/PostListItem";
import EmptyList from "components/app/EmptyList";
import Loading from "components/app/Loading";
import UserDetailBlock from "components/users/UserDetailBlock";

import { getUser, getUserV2 } from "redux/actions/user";
import { fetchUserPostList } from "redux/actions/post";

const Page = ({
  token,
  currentUser,
  userPostList,
}: {
  token: any;
  currentUser: any;
  userPostList: any;
}) => {
  const router = useRouter();
  const { id } = router.query;
  const { posts = [], pager } = userPostList || {};
  const [user, setUser] = useState<any>();

  useEffect(() => {
    const action = token ? getUserV2(token, id) : getUser(id);
    action.then((user: any) => {
      setUser(user);
    });
  }, [token, id]);

  return (
    user && (
      <UserLayout
        pageTitle={`用户 ${user.nickname}`}
        user={user}
        currentUser={currentUser}
      >
        <UserDetailBlock user={user} />
        <Card>
          <UserNavs user={user} activeKey="posts" />
          {userPostList ? (
            posts.length ? (
              posts.map(
                (post: any) =>
                  post && <PostListItem post={post} key={post.id} />
              )
            ) : (
              <EmptyList />
            )
          ) : (
            <Loading />
          )}
          <Pager pager={pager} onPageChange={() => {}} />
        </Card>
      </UserLayout>
    )
  );
};

const mapStateToProps = (state: any) => ({
  token: state.user.token,
  currentUser: state.user.user,
  event: state.app.event,
});

Page.getInitialProps = async (ctx: any) => {
  const { query } = ctx;
  const { id, page } = query;
  const userPostList = await fetchUserPostList(id, {
    page: parseInt(page) || 1,
  });
  return { userPostList };
};

export default connect(mapStateToProps)(Page);
